import React, { useEffect, useState } from 'react';
import { Radio, Select } from 'antd';
import { useSelector } from 'react-redux';
import { handleSetInitialValues, triggerNotification, useGetApiRequests } from '../../../../../../common/CommonExport';
import { useDispatch } from 'react-redux';
import { setProfileLoad } from '../../../../../../redux/slices/updateProfileSlice';
import { setEventData } from '../../../../../../redux/slices/empEventsSlice';
import Loader from '../../../../../../components/Loader/Loader';
import { useParams } from 'react-router-dom';
import { useIsMobile } from '../../../../../../hooks/commonHooks';

const EmployeAssets = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const isMobile = useIsMobile();
  const getAssetDetails = useGetApiRequests('getAssetDetails', 'GET');
  const updateEmployeeDetails = useGetApiRequests('companyEmployeeDetails', 'PUT');
  const employeeDetails: any = useSelector((state: any) => state?.eventData?.particularEmployeeDetails);
  const roleName = useSelector((state: any) => state?.loginUserData?.userData?.data?.role?.name);
  const [loader, setLoader] = useState<any>(false);
  const [assetDetails, setAssetDetails] = useState<any>([]);
  const [companyDto, setCompanyDto] = useState<any>({});
  const [initialValues, setInitialValues] = useState<any>();
  const [employeeImage, setEmployeeImage] = useState<any>();
  const [imageData, setImageData] = useState<any>(new FormData());
  const [configurationType, setConfigurationType] = useState(employeeDetails?.employeeAssertInfo?.assertType !== null ? employeeDetails?.employeeAssertInfo?.assertType : 'Basic');

  const [initialConfigType, setInitialConfigType] = useState<string>('Basic');
  const [assetId, setAssetId] = useState();
  const getConfigurationIdAPI = async () => {
    try {
      const res: any = await getAssetDetails('');
      setAssetDetails(res?.data?.data);
    } catch (err) {
    }
  };

  useEffect(() => {
    getConfigurationIdAPI();
    const configType = employeeDetails?.employeeAssertInfo?.assertType !== null
      ? employeeDetails?.employeeAssertInfo?.assertType
      : 'Basic';
    setConfigurationType(configType);
    setInitialConfigType(configType);
  }, []);
  useEffect(() => {
    handleSetInitialValues(employeeDetails, setEmployeeImage, setInitialValues, setCompanyDto);
  }, [employeeDetails])
  function findChangedData(obj1: any, obj2: any) {
    const changedData: any = {};
    for (const key in obj1) {
      if (obj1[key] !== obj2[key]) {
        changedData[key] = obj2[key];
      }
    }
    return changedData;
  }
  const onSubmit = () => {
    const changedData = findChangedData(companyDto, initialValues?.companyDto);
    const mainPayload = {
      employeeDto: initialValues?.employeeDto,
      companyDto: changedData,
      assertId: assetId
    };
    if (imageData === '') {
      mainPayload.employeeDto.profileUrl = null;
    } else {
      mainPayload.employeeDto.profileUrl = employeeImage;
    }

    setLoader(true);
    const headers = { 'Content-Type': 'multipart/form-data' };
    updateEmployeeDetails(imageData === '' ? {} : imageData, { employeeInformationDto: mainPayload }, { id: id }, headers)
      .then((res: any) => {
        dispatch(setProfileLoad());
        triggerNotification('success', '', res?.data?.status?.message, 'topRight');
        dispatch(setEventData({}));
        setInitialConfigType(configurationType);
        setLoader(false);
      })
      .catch((err: any) => {
        setLoader(false);
        triggerNotification('error', '', err?.response?.data?.message ?? err?.response?.data?.status?.message, 'topRight');
      })
      .finally(() => {
        setLoader(false);
      });
  };


  const assetConfig = [
    { "label": "Basic", value: 'Basic' },
    { "label": "Intermediate", value: 'Intermediate' },
    { "label": "Advanced", value: 'Advanced' }
  ];
  const assetType = [
    { "label": "Laptop", value: 'Laptop' },
    { "label": "Desktop", value: 'Desktop' },
  ];

  const handleChange = (value: string) => {
    const selectedAsset = assetDetails?.find((asset: any) => asset?.assertType === value);
    const assertId = selectedAsset ? selectedAsset?.assertId : null;
    setAssetId(assertId);
    setConfigurationType(value);
  };

  const selectedAssetDetails = assetDetails?.find((asset: any) => asset?.assertType === configurationType);
  return (
    <div className='salary_details font-rubik'>
      {loader && <Loader />}
      <div className="employee-assets  mt-5">
        <div className="configuration-section mb-8 2xl:p-6 p-4 bg-white rounded-lg border border-gray-200 shadow-sm">
          <h3 className="text-lg font-semibold text-gray-800 mb-6 pb-2 border-b border-gray-200">Configuration Details</h3>

          <div className="flex flex-col space-y-6">
            <div className="flex items-center label-row">
              <div className="w-48 flex-shrink-0">
                <label className='font-rubik text-gray-700 font-medium'>Configuration Type</label>
              </div>
              <div className="flex-1 ">
                <Select
                  disabled={isMobile ? true : !(roleName === "IT Admin" || roleName === "HR Admin")}
                  className='font-rubik w-full max-w-xs'
                  value={configurationType}
                  onChange={handleChange}
                  options={assetConfig.map(option => ({ label: option.label, value: option.value }))}
                />
              </div>
            </div>


            {selectedAssetDetails && (
              <div className="bg-gray-50 rounded-md p-4">
                <div className="grid grid-cols-2 sm:grid-cols-3 gap-6">
                  <div className="space-y-1">
                    <label className='font-rubik text-xs sm:text-sm text-gray-500 uppercase tracking-wider'>
                      Processor
                    </label>

                    <p className='font-rubik text-gray-800 font-medium'>
                      {selectedAssetDetails?.processor || '-'}
                    </p>
                  </div>


                  <div className="space-y-1">
                    <label className='font-rubik text-xs sm:text-sm text-gray-500 uppercase tracking-wider'>RAM</label>
                    <p className='font-rubik text-gray-800 font-medium'>
                      {selectedAssetDetails?.ram || '-'}
                    </p>
                  </div>

                  <div className="space-y-1">
                    <label className='font-rubik text-xs sm:text-sm text-gray-500 uppercase tracking-wider'>SSD</label>
                    <p className='font-rubik text-gray-800 font-medium'>
                      {selectedAssetDetails?.ssd || '-'}
                    </p>
                  </div>
                  <div className="space-y-1">
                    <label className='font-rubik text-xs sm:text-sm text-gray-500 uppercase tracking-wider'>Graphics Card</label>
                    <p className='font-rubik text-gray-800 font-medium'>
                      {selectedAssetDetails?.graphicCard || '-'}
                    </p>
                  </div>
                  <div className="space-y-1">
                    <label className='font-rubik text-xs sm:text-sm text-gray-500 uppercase tracking-wider'>OS</label>
                    <p className='font-rubik text-gray-800 font-medium'>
                      {selectedAssetDetails?.os || '-'}
                    </p>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>

        <div className="device-section device-type-box p-6 bg-white rounded-lg border border-gray-200 shadow-sm mb-8">
          <h3 className="text-lg font-semibold text-gray-800 mb-6 pb-2 border-b border-gray-200">Device Information</h3>

          <div className="space-y-6">

            <div className="flex items-center ">
              <div className="w-48 flex-shrink-0 label-box">
                <label className='font-rubik text-gray-700 font-medium'>Device Type</label>
              </div>
              <div className="flex-1">
                <Radio.Group
                  className='font-rubik'
                  name="deviceType"
                  disabled={true}
                  value={employeeDetails?.deviceType !== null ? employeeDetails?.deviceType : 'Laptop'}
                  options={assetType}
                />
              </div>
            </div>


            <div className="flex items-center">
              <div className="w-48 flex-shrink-0 label-box">
                <label className='font-rubik text-gray-700 font-medium'>Other Peripherals</label>
              </div>
              <div className="flex-1">
                <p className='font-rubik text-gray-800 font-medium'>
                  {employeeDetails?.otherPeripherals !== "" ? employeeDetails?.otherPeripherals : 'N/A'}
                </p>
              </div>
            </div>
          </div>
        </div>


        {!isMobile && (roleName === "IT Admin" || roleName === "HR Admin") && (
          <div className='flex justify-end'>
            <button
              className={`addButton mr-4 primary  ${configurationType === initialConfigType ? "disabled" : ""}`}
              type="submit"
              onClick={onSubmit}
              disabled={configurationType === initialConfigType}
            >
              Update Configuration
            </button>
          </div>
        )}
      </div>
    </div>
  );
}

export default EmployeAssets;